<template>
  <div class="px-2">
    <div class="mb-1">
      <v-btn class="mr-2" v-if="report && !capturing" @click="printData" x-small width="30" height="30"
             color="primary">
        <v-icon x-small>fas fa-print</v-icon>
      </v-btn>

      <v-btn v-if="report && !capturing" @click="saveDocument" x-small
             width="30" height="30"
             color="primary">
        <v-icon x-small>fas fa-save</v-icon>
      </v-btn>
    </div>
    <div v-if="report" v-html="report">
    </div>
    <div class="d-flex justify-center align-center" style="height: 90vh" v-if="errorMessage">
      <h1 class="error--text">{{ errorMessage }}</h1>
    </div>
  </div>
</template>

<script>

import {downloadTextFile} from "@/utils/pureFunctions";


export default {
  props: ['creditId'],
  data() {
    return {
      report: null,
      errorMessage: null,
      capturing: false
    }
  },
  methods: {
    saveDocument() {
      this.capturing = true
      this.$nextTick(() => {
        downloadTextFile('user-info.html', document.querySelector("html").innerHTML)
        this.capturing = false
      })
    },
    printData() {
      this.capturing = true
      this.$nextTick(() => {
        window.print()
        this.capturing = false
      })
    },
    setError(e) {
      if (e.response && e.response.data && e.response.data.message) {
        this.errorMessage = e.response.data.message
      }
    },
    parseTextToHtml(text) {
      let pattern = /<body[^>]*>((.|[\n\r])*)<\/body>/im;
      text = text.split(pattern)
      if (text[1]) {
        return text[1].replace(/\n/g, '').replace(/>[\t ]+</g, "><")
      }
      return text[1]
    },
    async getReportByCreditId() {
      try {
        this.errorMessage = null
        const {data: {data}} = await this.$http.get(`/admin/credit/katm/info/${this.creditId}`)
        this.report = this.parseTextToHtml(data)
      } catch (e) {
        this.$setResponseError({error: e})
        this.setError(e)
      }
    },
    async getReportByUser({
                            pnfl,
                            passport_series,
                            passport_number,
                            region_katm_code,
                            district_katm_code,
                            user_phone,
                            credit_id
                          }) {
      try {
        const formData = {
          pnfl,
          passport_series,
          passport_number,
          user_phone,
          district_katm_code,
          region_katm_code,
        }
        if (credit_id) {
          formData.credit_id = credit_id
        }
        const {data: {data}} = await this.$http.post('admin/calculate/katm', formData)
        this.report = this.parseTextToHtml(data)
      } catch (e) {
        this.$setResponseError({error: e})
        this.setError(e)
      }

    }
  },
  computed: {
    isReportByCreditId() {
      return !!this.creditId
    },
    subjectClaimsSum() {
      let subjectClaims = {
        claims_qty: 0,
        rejected_qty: 0,
        granted_qty: 0
      }
      if (!this.report || !this.report.subject_claims) return subjectClaims
      try {
        const {retail_claims, mko_claims, lombard_claims, leasing_claims, bank_claims} = this.report.subject_claims
        subjectClaims.claims_qty = retail_claims.claims_qty + mko_claims.claims_qty + lombard_claims.claims_qty + leasing_claims.claims_qty + bank_claims.claims_qty
        subjectClaims.rejected_qty = retail_claims.rejected_qty + mko_claims.rejected_qty + lombard_claims.rejected_qty + leasing_claims.rejected_qty + bank_claims.rejected_qty
        subjectClaims.granted_qty = retail_claims.granted_qty + mko_claims.granted_qty + lombard_claims.granted_qty + leasing_claims.granted_qty + bank_claims.granted_qty
      } catch (e) {
        console.error(e)
      }
      return subjectClaims
    }

  },
  async mounted() {
    const {
      pnfl,
      passport_series,
      passport_number,
      region_katm_code,
      district_katm_code,
      user_phone,
      credit_id
    } = this.$route.query
    this.$showLoading()
    if (this.isReportByCreditId) {
      await this.getReportByCreditId()
    } else if (pnfl && passport_number && passport_series && region_katm_code && district_katm_code && user_phone) {
      await this.getReportByUser({
        pnfl,
        passport_series,
        passport_number,
        region_katm_code,
        district_katm_code,
        user_phone,
        credit_id
      })
    }
    const tables = document.querySelectorAll('table')
    Array.prototype.forEach.call(document.querySelectorAll('table'), item => {
      const wrapper = document.createElement('div')
      wrapper.style.cssText = 'overflow: auto;'
      item.parentNode.appendChild(wrapper)
      wrapper.appendChild(item)
    })
    this.$clearLoading()
  }
}
</script>

<style lang="scss">
.fixed-section {

}

#main_block table {
  font-size: 11px;
  width: 100%;
  border-collapse: collapse;

  td {
    height: 30px;
  }

}

#content_general {
  overflow: auto;
}

.report_table_class table,
.table_personal_class table {
  background: #fff;
  border-radius: 10px;

  tr + tr {
    border-top: 1px solid #E5E5E5;
  }

  td td {
    padding-left: 10px;
    padding-right: 10px;
  }
}


.header-color {
  background-color: transparent;
  padding-left: 10px;
  padding-right: 10px;
}

.mip-color {
  background-color: #e3fbf7;
}

.procent25_class {
  width: 25%;
  padding-left: 10px;
  padding-right: 10px;
}

@media screen and (max-width: 599px) {
  .print-btn {
    left: 5px;
    top: 5px;
  }
  #headerMKB {
    tbody tr, tbody, tbody tr td, table {
      display: block;
    }

    td {
      width: 100% !important;
      text-align: center;
      height: auto !important;
    }
  }
}
</style>
